/* eslint-disable no-unexpected-multiline */
import { useState, useEffect, SetStateAction, Dispatch, useRef } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import {
  Button,
  CheckBox,
  Col,
  Form,
  Grid,
  Input,
  InputFile,
  Row,
  Span,
  SuccessModal,
  ChipInput,
  AutoCompleteInput,
  TextArea,
  UnidadeGestoraFields,
  Picker,
  CurrencyInput
} from 'components'
import SimpleCollapse from 'components/Collapse/SimpleCollapse'
import { LoadingIcon, MagnifyingGlassIcon } from 'components/Icons'
import { useDebounce, useEnvironment, useModal } from 'hooks'
import useAuth from 'hooks/useAuth'
import useLoading from 'hooks/useLoading'
import useToggle from 'hooks/useToggle'
import { set, useForm } from 'react-hook-form'
import {
  ContractNGTServices,
  CreateContractNgt,
  ICentroPlanta,
  ISaveFileRequest,
  IContractForm,
  IGrupoMercadoriaResponse,
  IHierarquiaProdutoResponse
} from 'services/NGT/Contract'
import { CompanyServices } from 'services/NGT/Files'
import { SupplierRegistrationServices } from 'services/NGT/SupplierRegistration'
import { UserCsnService } from 'services/Supplier/Users'
import { UnidadeGestoraServices } from 'services/Utils/UnidadeGestora'
import { COLORS, FONTS, FORMAT, SPACING, TYPOGRAPHY } from 'utils'
import { convertBase64, preventDefaultOnEnter } from 'utils/functions'
import { ITypeUpload } from 'utils/types'

import AttachedFiles from './components/AttachedFiles'
import { SCHEMA } from './yup/schema'

interface FormProps {
  setTab?: Dispatch<SetStateAction<number>>
  flPrincipal?: boolean
  costCenters: ICentroPlanta[]
  setToggleToClear: (_toggle: boolean) => void
  sectors: any
  unidadesGestoras: any
  tipoCre: any
  grpMercadorias: IGrupoMercadoriaResponse[]
  hierarquiaProdutos: IHierarquiaProdutoResponse[]
}

export const AddNewContract: React.FC<FormProps> = ({
  setTab,
  tipoCre,
  costCenters,
  sectors,
  grpMercadorias,
  hierarquiaProdutos,
  setToggleToClear
}) => {
  const { setLoading, setMsgErro } = useLoading()
  const { user } = useAuth()
  const {
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    setError,
    clearErrors,
    getFieldState,
    getValues,
    formState: { errors }
  } = useForm({ resolver: yupResolver(SCHEMA.noSapContractForm) })

  const [empresas, setEmpresas] = useState<
    { nmEmpresa: string; idEmpresa: number }[]
  >([])
  const { showModal } = useModal()
  const [isFornSearched, setIsFornSearched] = useState<string>('')
  const [isSearchForn, setIsSearchForn] = useState<boolean>(false)
  const [unidadeGestoraId, setUnidadeGestoraId] = useState<number>()
  const [searchFile, setSearchFile] = useState<string>('')
  const [, setFileToDelete] = useState<number[]>([])
  const [arquivosSelecionados, setArquivosSelecionados] = useState<
    ITypeUpload[]
  >([])
  const [subContract] = useState<any | null>(null)

  const [loadingEvidencia] = useState<boolean>(false)
  const [successMsg] = useState<string>('')
  const [isSuccess, setSuccess] = useState<boolean>(false)
  const [isError, toggleError] = useToggle()
  const [substituteErrorMsg] = useState<string>('')

  const [flagContratoEncerrado, setFlagContratoEncerrado] =
    useState<boolean>(false)
  const [flagSubcontrato, setFlagSubcontrato] = useState<boolean>(false)
  const [flagSocio, setFlagSocio] = useState<boolean>(false)
  const [flagDenuncia, setFlagDenuncia] = useState<boolean>(false)
  const [flagAlerta, setFlagAlerta] = useState<boolean>(false)
  const [flagRecorrente, setFlagRecorrente] = useState<boolean>(false)
  const countTextArea = watch('txObjetoContrato')
  const inputTypingValue = useRef<string>('')

  const [selectedContraparte, setSelectedContraparte] = useState<any>()
  const [selectedMatriculaContraparte, setSelectedMatriculaContraparte] =
    useState<any>()
  const [selectedComprador, setSelectedComprador] = useState<any>()
  const [selectedMatriculaComprador, setSelectedMatriculaComprador] =
    useState<any>()
  const [selectedGrupoMercadoria, setSelectedGrupoMercadoria] =
    useState<string>()
  const [selectedHierarquiaProduto, setSelectedHierarquiaProduto] = useState<
    number | string
  >()
  const [idUnidadecomprador, setIdUnidadecomprador] = useState<number>(0);
  const [contraparteId, setContraparteId] = useState(0)
  const [compradorId, setCompradorId] = useState<number>(null)
  const [isSub] = useState(false)

  const [flExclusao, setFlExclusao] = useState<boolean[]>([])
  const [flEmailRepetido, setFlEmailRepetido] = useState<boolean>(false);

  const { website_url } = useEnvironment()

  const [descricaoHierarquiaProduto, setDescricaoHierarquiaProduto] =
    useState<string>('')

  const [substitutoList, setSubstitutoList] = useState([
    {
      emailSubstituto: '',
      idSubstituto: 0,
      matriculaSubstituto: '',
      nmSubstituto: '',
      ramalSubstituto: ''
    }
  ])
  const [matriculas, setMatriculas] = useState<
    {
      label: string
      value: any
    }[]
  >([{ label: '', value: {} }])

  const [analistas, setAnalistas] = useState<
    {
      label: string
      value: any
    }[]
  >([{ label: '', value: {} }])

  const dtCadastro = new Date()
  const flSap = false
  const centroPlantaName = watch('centroPlantaName')
  const matriculaContraparte = watch('matriculaContraparte')
  const creName = watch('creName')
  const setorName = watch('setorName')
  const documento = watch('cnpj')
  const dtVigenciaFim = watch('dtVigenciaFim')
  const dtVigenciaInicio = watch('dtVigenciaInicio')
  const dtVigFimReal = watch('dtVigFimReal')
  const dtVigInicioReal = watch('dtVigInicoReal')

  const getEmpresas = () => {
    CompanyServices()
      .getAll()
      .then(({ data }) => {
        const empresas: { nmEmpresa: string; idEmpresa: number }[] = []
        data?.map((contrato) => {
          empresas.push({
            idEmpresa: contrato.idEmpresa,
            nmEmpresa: contrato.txDescricao
          })
        })
        setEmpresas(empresas)
      })
      .catch(() => {
        // setMsgErro('Não foi possivel obter as Empresas.')
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter as Empresas.',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleChangeInput = (value, field) => setValue(field, value)

  const generateInputToken = (length = 10) => {
    let aleatoryString = ''

    const caracteres =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    for (let i = 0; i < length; i++) {
      aleatoryString += caracteres.charAt(
        Math.floor(Math.random() * caracteres?.length)
      )
    }

    return aleatoryString
  }

  const handleFilterFilesTable = () => {
    if (searchFile !== '') {
      return arquivosSelecionados?.filter(
        (file) =>
          file?.dsDocumento?.toLowerCase().includes(searchFile.toLowerCase()) ||
          file?.dsExtensaoDoc?.toLowerCase().includes(searchFile.toLowerCase())
      )
    }

    return arquivosSelecionados
  }

  const getUnidadeComprador = (idUnidadeComprador: number) => {
    setLoading('loading')
    UnidadeGestoraServices().getById(idUnidadeComprador).then(response => {
      if (response?.status == 200) {
        handleChangeInput(response?.data?.numeroUnidade, "unidadeComprador")
        setLoading("idle")
      } else {
        showModal({
          message: 'Ocorreu um problema ao buscar a unidade do comprador.',
          txtButtonCancel: '',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
        setLoading("idle")
      }
    }).catch(() => {
      showModal({
        message: 'Ocorreu um problema ao buscar a unidade do comprador.',
        txtButtonCancel: '',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
      setLoading("idle")
    })
  }

  const handleFileToDelete = (file: ITypeUpload) => {
    if (file.anexoDocumentoId) {
      // Documento já está na base, insere na lista de ids a serem deletados
      setFileToDelete((prevState) => [...prevState, file.anexoDocumentoId])
    }

    // Documento temporário ainda não salvo, só remove do estado
    setArquivosSelecionados((prevState) =>
      prevState.filter((evidencia) => evidencia !== file)
    )
  }

  const handleChangeFile = async (files) => {
    if (files) {
      setLoading('loading')
      // try {
      for (let i = 0; i < files?.length; i++) {
        const fileBase64 = (await convertBase64(files[i])) as string
        const newObj: ITypeUpload = {
          base64: FORMAT.file(fileBase64),
          documentoExternoGedId: String(generateInputToken(10)),
          dsDocumento: files[i].name,
          dsExtensaoDoc: files[i].type || 'application/octet-stream'
        }

        setArquivosSelecionados((prevState) => [...prevState, newObj])
      }
      setLoading('idle')
    }
  }

  const handleClearForm = () => {
    setFlagContratoEncerrado(false)
    setFlagSubcontrato(false)
    setFlagSocio(false)
    setFlagDenuncia(false)
    setFlagAlerta(false)
    setFlagRecorrente(false)
    setSelectedContraparte('')
    setSelectedMatriculaContraparte('')
    setValue('matriculaContraparte', '')
    setValue('nmContraparte', '')
    setValue('ramalContraparte', '')
    setValue('emailContraparte', '')
    setValue('idUnidadeGestora', 0)
    setUnidadeGestoraId(0)
    setSelectedComprador('')
    setSelectedMatriculaComprador('')
    setValue('matriculaComprador', '')
    setValue('nmCoprador', '')
    setValue('ramalComprador', '')
    setValue('emailComprador', '')
    setSelectedGrupoMercadoria('')
    setValue('cdGrupoMercadoria', '')
    setValue('descGrupoMercadoria', '')
    setSelectedHierarquiaProduto(null)
    setValue('cdHierarquiaProd', '')
    setValue('descHierarquiaProduto', '')

    setSubstitutoList([
      {
        emailSubstituto: '',
        idSubstituto: 0,
        matriculaSubstituto: '',
        nmSubstituto: '',
        ramalSubstituto: ''
      }
    ])

    reset({
      CRE: '',
      cdContrato: '',
      cdGrupoMercadoria: '',
      cdHierarquiaProd: '',
      centroPlantaId: '',
      centroPlantaName: '',
      creName: '',
      descGrupoMercadoria: '',
      descHierarquiaProduto: '',
      dtVigFimReal: '',
      dtVigInicoReal: '',
      emailComprador: '',
      emailContraparte: '',
      emailsTrabalhistas: [],
      empresa: '',
      flAlerta: false,
      flDenuncia: false,
      flEncerrado: false,
      flRecorrente: false,
      flSocio: false,
      flSubcontrato: '',
      idUnidadeGestora: 0,
      matriculaContraparte: '',
      nmEmpresa: '',
      nmFornecedor: '',
      nmUnidadeGestora: '',
      ramalComprador: '',
      ramalContraparte: '',
      setorId: '',
      setorName: '',
      txAlerta: '',
      txCno: '',
      txDenuncia: '',
      txObservacao: ''
    })
    setToggleToClear(true)
  }

  const handleSubmitForm = async (form: IContractForm) => {
    if (!isSearchForn || isFornSearched != FORMAT.unMask(form?.cnpj))
      return getSupplierByCnpj(form.cnpj)

    const selectedUserFiles = arquivosSelecionados?.filter(
      (files: ITypeUpload) => files.base64
    )

    if (flagContratoEncerrado && arquivosSelecionados?.length <= 0) {
      showModal({
        hideButtonCancel: true,
        message: 'Por favor, Anexe evidências que o contrato foi encerrado.',
        titleModal: 'Atenção',
        txtButtonConfirm: 'OK',
        type: 'alert'
      })
      setLoading('idle')
      return
    }

    const filesToSave: ISaveFileRequest[] =
      selectedUserFiles?.length > 0
        ? arquivosSelecionados?.map((file: ITypeUpload) => ({
          descricao:
            file.dsExtensaoDoc != '' || file.dsExtensaoDoc != null
              ? file.dsExtensaoDoc
              : 'DOCUMENTO CONTRATO',
          file: FORMAT.file(file.base64),
          nomeArquivo: file.dsDocumento,
          nuAnoMesCompetencia: parseInt(FORMAT.formatYYYYMM(new Date())),
          tipoDocumentoId: 1,
          tipoPendenciaId: 13,
          usuarioId: user.IdUsuario
        }))
        : []

    const idSubstitutoList: number[] | undefined =
      substitutoList[0].idSubstituto !== 0
        ? substitutoList?.map((substituto) => substituto.idSubstituto)
        : undefined

    const txEmail = [
      ...new Set(
        form?.emailsTrabalhistas.filter((email: string, index) => flExclusao[index] !== true && email.toLowerCase())
      )
    ]

    const createContractObj: CreateContractNgt = {
      cdContrato: form.cdContrato,
      cdGrupoMercadoria: form.cdGrupoMercadoria,
      centroPlantaId: form.centroPlantaId,
      compradorUsuarioId: compradorId,
      contraparteUsuarioId: contraparteId,
      dtVigFimReal: form.dtVigFimReal,
      dtVigInicoReal: form.dtVigInicoReal,
      dtVigenciaFim: form.dtVigenciaFim,
      dtVigenciaInicio: form.dtVigenciaInicio,
      empresaId: form.empresa,
      flAlerta: form.flAlerta || false,
      flAtivo: true,
      flDenuncia: form.flDenuncia || false,
      flEncerrado: form.flEncerrado || false,
      flRecorrente: form.flRecorrente || false,
      flSocio: form.flSocio || false,
      flSubcontrato: form.flSubcontrato || false,
      fornecedorId: form.fornecedor,
      hierarquiaId: parseInt(form.cdHierarquiaProd),
      idUnidGestora: form.idUnidadeGestora,
      listAnexarDocs: filesToSave,
      listContraparteSubstituto: idSubstitutoList,
      setorContratoId: form.setorId,
      tipoCreId: parseInt(form.CRE),
      txAlerta: form.txAlerta,
      txCno: form.txCno,
      txDenuncia: form.txDenuncia,
      txEmail: txEmail,
      txObjetoContrato: form.txObjetoContrato,
      txObservacao: form.txObservacao,
      url: website_url,
      vlContratual: parseFloat(form.vlContratual)
    }

    setLoading('loading')
    ContractNGTServices()
      .create(createContractObj)
      .then((response) => {
        if (response.status !== 200 || response.data.mensagem) {
          throw new Error(
            response.data.mensagem || 'Não foi possivel salvar o Contrato.'
          )
        }

        showModal({
          hideButtonCancel: true,
          message: 'Contrato salvo com sucesso!',
          type: 'success'
        })
        setTab(0)
        setLoading('idle')
      })
      .catch((error: Error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: error.message,
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleSelectedContraparte = (value) => {
    setSelectedContraparte(value.usuario?.nmUsuario)
    setSelectedMatriculaContraparte(value.nmMatricula)
    setValue('matriculaContraparte', value.nmMatricula)
    setValue('nmContraparte', value.usuario?.nmUsuario)
    setValue('ramalContraparte', value.usuario?.nuRamal)
    setValue('emailContraparte', value.usuario?.txEmail)
    setValue('idUnidadeGestora', value?.idUnidGestora)
    setUnidadeGestoraId(value?.idUnidGestora)
    setContraparteId(value.usuario?.idUsuario)

    const _matriculaContraparte = watch('matriculaContraparte')
    const _nmContraparte = watch('nmContraparte')

    if (_matriculaContraparte && _nmContraparte) {
      clearErrors('matriculaContraparte')
      clearErrors('nmContraparte')
    }
  }

  const handleSelectedComprador = (value) => {
    setSelectedComprador(value.usuario?.nmUsuario)
    setSelectedMatriculaComprador(value?.nmMatricula)
    setValue('matriculaComprador', value?.nmMatricula)
    setValue('nmCoprador', value.usuario?.nmUsuario)
    setValue('ramalComprador', value.usuario?.nuRamal)
    setValue('emailComprador', value.usuario?.txEmail)
    setCompradorId(value.usuario?.idUsuario)
    setIdUnidadecomprador(value?.idUnidGestora ?? 0)
  }

  const handleSelectedGrpMercadoria = (codigo: string, descricao: string) => {
    setSelectedGrupoMercadoria(codigo)
    setValue('cdGrupoMercadoria', codigo)
    setValue('descGrupoMercadoria', codigo ? descricao : '')

    const _cdGrupoMercadoria = watch('cdGrupoMercadoria')
    const _descGrupoMercadoria = watch('descGrupoMercadoria')

    if (_cdGrupoMercadoria && _descGrupoMercadoria) {
      clearErrors('cdGrupoMercadoria')
      clearErrors('descGrupoMercadoria')
    }
  }

  const handleSelectedHierarquiaProduto = (
    cdHierarquia: string,
    idHierarquia: number,
    txDescricao: string
  ) => {
    setSelectedHierarquiaProduto(cdHierarquia)
    setValue('cdHierarquiaProd', idHierarquia)
    setValue('descHierarquiaProduto', cdHierarquia)

    setDescricaoHierarquiaProduto(txDescricao)

    const _cdHierarquiaProd = watch('cdHierarquiaProd')
    const _descHierarquiaProduto = watch('descHierarquiaProduto')

    if (_cdHierarquiaProd && _descHierarquiaProduto) {
      clearErrors('cdHierarquiaProd')
      clearErrors('descHierarquiaProduto')
    }
  }

  const handleSearchMatricula = (event) => {
    setMatriculas([])
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByMatricula(event.target.value)
      .then((response) => {
        const selectedFieldOptions = response.data?.map((analista) => ({
          label: analista.nmMatricula,
          value: analista
        }))

        setMatriculas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível encontrar a matrícula',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const handleSearchAnalista = (event) => {
    setAnalistas([])
    setLoading('loading')
    if (event.target.value === '') {
      setLoading('idle')
      return
    }
    UserCsnService()
      .getByNome(event.target.value)
      .then((response) => {
        const selectedFieldOptions = response.data?.map((analista) => ({
          label: analista.usuario.nmUsuario,
          value: analista
        }))

        setAnalistas(selectedFieldOptions)
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possível encontrar o Analista',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
      })
  }

  const addSubstituto = () => {
    setSubstitutoList([
      ...substitutoList,
      {
        emailSubstituto: '',
        idSubstituto: 0,
        matriculaSubstituto: '',
        nmSubstituto: '',
        ramalSubstituto: ''
      }
    ])
  }

  const removeSubstituto = (position) => {
    setSubstitutoList([
      ...substitutoList.filter((_, index) => index !== position)
    ])
  }

  const handleSelectedSubstituto = (substituto, index) => {
    substitutoList[index].idSubstituto = substituto?.usuarioId
    substitutoList[index].matriculaSubstituto = substituto?.nmMatricula
    substitutoList[index].nmSubstituto = substituto.usuario?.nmUsuario
    substitutoList[index].ramalSubstituto = substituto.usuario?.nuRamal
    substitutoList[index].emailSubstituto = substituto.usuario?.txEmail
    setSubstitutoList([...substitutoList])
  }

  const getSupplierByCnpj = (cnpj: string) => {
    if (cnpj?.length > 0) {
      setLoading('loading')

      SupplierRegistrationServices()
        .getByCnpj(FORMAT.unMask(cnpj))
        .then(({ data }) => {
          setIsFornSearched(FORMAT.unMask(cnpj))
          //CHIPINPUT
          const emails = data.tFornecedorContatos?.map(
            (contatoFornecedor) => contatoFornecedor.txEmail
          )
          emails.forEach(() => setFlExclusao(prevState => ([...prevState, false])));
          setIsSearchForn(true)
          handleChangeInput(
            [...getValues('emailsTrabalhistas'), ...emails].filter(
              (value, index, self) => self.indexOf(value) === index
            ),
            'emailsTrabalhistas'
          )
          const currentEmailsTrabalhistas = getValues('emailsTrabalhistas');
          // const emailExists = emails.some(email => email.)
          handleChangeInput(data.idFornecedor, 'fornecedor')
          handleChangeInput(data.nmFornecedor, 'nmFornecedor')
          setLoading('idle')
        })
        .catch(() => {
          setIsSearchForn(false)
          handleChangeInput('', 'fornecedor')
          handleChangeInput([], 'emailsTrabalhistas')
          handleChangeInput('', 'cnpj')
          handleChangeInput('', 'nmFornecedor')
          setLoading('idle')
          showModal({
            hideButtonCancel: true,
            message: 'Fornecedor não cadastrado',
            txtButtonConfirm: 'Fechar',
            type: 'error'
          })
        })
    }
  }

  useEffect(() => {
    getEmpresas()
  }, [])

  useEffect(() => {
    if (idUnidadecomprador !== 0)
      getUnidadeComprador(idUnidadecomprador)
    else
      handleChangeInput("", "unidadeComprador")

  }, [idUnidadecomprador])

  useEffect(() => {
    if (arquivosSelecionados) {
      handleFilterFilesTable()
    }
  }, [arquivosSelecionados])



  return (
    <>
      <Form
        onSubmit={handleSubmit(handleSubmitForm)}
        onKeyDown={preventDefaultOnEnter}
        marginLeft={SPACING.spacing20}
        marginRight={SPACING.spacing20}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        boxShadow={`0 0 1em ${COLORS.lightGray}`}
      >
        <SimpleCollapse title="INFORMAÇÕES GERAIS" isExpanded>
          <Row
            marginTop={SPACING.spacing10}
            marginBottom={SPACING.spacing20}
            justifyContent="space-between"
          >
            <Row marginTop={SPACING.spacing10}>
              <Span
                text="Data Cadastro:"
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
                marginRight={SPACING.spacing5}
              />
              <Span
                text={FORMAT.formatDDMMYYYY(dtCadastro)}
                color={COLORS.blueFonts}
                fontSize={TYPOGRAPHY.bodySize16}
                fontWeight={FONTS.bold}
              />
            </Row>
            <Row justifyContent="flex-end">
              <CheckBox
                marginRight={SPACING.spacing15}
                label="Importado pelo SAP"
                checked={flSap}
                disabled
              />
            </Row>
          </Row>
          <Grid
            gridCols="1fr 1.2fr 2.4fr 1.70fr 1.70fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              control={control}
              errors={errors}
              label="Contrato"
              placeholder="Nº"
              formValue="cdContrato"
              maxLength={15}
            />
            <Input
              control={control}
              errors={errors}
              label="CPF/CNPJ/Cód.Fornecedor"
              placeholder="Nº"
              formValue="cnpj"
              mask={
                documento && documento.length > 9
                  ? ['###.###.###-##', '##.###.###/####-##']
                  : ['#########']
              }
              maxLength={18}
              inputIcon={<MagnifyingGlassIcon />}
              onClickIcon={() => getSupplierByCnpj(documento)}
            />
            <Input
              control={control}
              errors={errors}
              label="Fornecedor"
              placeholder="Nome do fornecedor"
              formValue="nmFornecedor"
              disabled
            />
            <AutoCompleteInput
              marginTop="0.25rem"
              control={control}
              errors={errors}
              label="Empresa"
              formValue="empresa"
              options={empresas}
              optionValue="nmEmpresa"
              valueName="idEmpresa"
            />
            <AutoCompleteInput
              marginTop="0.25rem"
              control={control}
              errors={errors}
              defaultValue={centroPlantaName}
              label="Centro Planta"
              formValue="centroPlantaId"
              options={costCenters}
              optionValue="txDescricao"
              valueName="idCentroPlanta"
            />
          </Grid>
          <Grid
            gridCols="4fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <TextArea
              label="Objeto do contrato"
              control={control}
              errors={errors}
              formValue="txObjetoContrato"
              count={countTextArea?.length || 0}
              limitCount={150}
              maxLength={150}
            />
          </Grid>
          <Grid
            gridCols="3fr 3fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteInput
              marginTop="0.26rem"
              control={control}
              errors={errors}
              defaultValue={creName}
              label="CRE"
              formValue="CRE"
              options={tipoCre}
              optionValue="txDenominacao"
              valueName="idTipoCre"
            />
            <Input
              control={control}
              errors={errors}
              mask={['##.###.#####/##']}
              label="CNO ( Cadastro Nacional de Obras )"
              placeholder="CNO"
              formValue="txCno"
            />
          </Grid>

          <Grid
            gridCols="1fr 1fr 1fr 1fr"
            gridGap={`0 ${SPACING.spacing20}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Picker
              defaultValue={null}
              label="Início Vigência Contrato"
              formValue="dtVigenciaInicio"
              control={control}
              maxDate={dtVigenciaFim}
              errors={errors}
            />
            <Picker
              defaultValue={null}
              label="Fim Vigência Contrato"
              formValue="dtVigenciaFim"
              minDate={dtVigenciaInicio}
              control={control}
              errors={errors}
            />
            <Picker
              defaultValue={null}
              label="Início Vigência Real"
              formValue="dtVigInicoReal"
              maxDate={dtVigFimReal}
              errors={errors}
              control={control}
            />
            <Picker
              defaultValue={null}
              label="Fim Vigência Real"
              formValue="dtVigFimReal"
              minDate={dtVigInicioReal}
              errors={errors}
              control={control}
            />
          </Grid>

          <Grid
            gridCols="0.765fr 0.765fr 0.5fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <CurrencyInput
              control={control}
              errors={errors}
              label="Valor Contratual"
              placeholder="Valor"
              formValue="vlContratual"
              maxLength={16}
            />
            <AutoCompleteInput
              marginTop="0.26rem"
              defaultValue={setorName}
              options={sectors}
              optionValue="dsSetorContrato"
              label="Negócio"
              control={control}
              errors={errors}
              formValue="setorId"
              valueName="idSetorContrato"
            />

            <Col>
              <Span text="Tipo" />
              <CheckBox
                checked={flagRecorrente}
                label="Recorrente"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flRecorrente')
                  setFlagRecorrente(event.target.checked)
                }}
              />
            </Col>
            <Col>
              <Span text="Contrato" />
              <CheckBox
                checked={flagContratoEncerrado}
                label="Encerrado"
                onChange={(event) => {
                  handleChangeInput(event.target.checked, 'flEncerrado')
                  setFlagContratoEncerrado(event.target.checked)
                }}
              />
            </Col>
            <CheckBox
              marginTop="1rem"
              checked={flagSocio}
              label="Sócio"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flSocio')
                setFlagSocio(event.target.checked)
              }}
            />
          </Grid>

          <Span fontSize="1em" text="Notificação" />
          <Grid
            gridCols={
              !isSub ? '0.8fr 0.8fr 0.8fr 2fr 2fr' : '0.8fr 0.8fr 2fr 2fr'
            }
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <CheckBox
              checked={flagDenuncia}
              label="Denúncia"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flDenuncia')
                setFlagDenuncia(event.target.checked)
                if (!event.target.checked) {
                  handleChangeInput('', 'txDenuncia')
                }
              }}
            />
            <CheckBox
              checked={flagAlerta}
              label="Alerta"
              onClick={(event) => {
                handleChangeInput(event.target.checked, 'flAlerta')
                setFlagAlerta(event.target.checked)
                if (!event.target.checked) {
                  handleChangeInput('', 'txAlerta')
                }
              }}
            />
            {!isSub && (
              <CheckBox
                checked={flagSubcontrato}
                label="Solicitação Subcontrato"
                onClick={(event) => {
                  handleChangeInput(event.target.checked, 'flSubcontrato')
                  setFlagSubcontrato(event.target.checked)
                }}
              // disabled
              />
            )}
            <Input
              maxLength={1000}
              control={control}
              errors={errors}
              label="Denúncia"
              placeholder="Justifique"
              formValue="txDenuncia"
              disabled={!flagDenuncia}
            />
            <Input
              maxLength={1000}
              control={control}
              errors={errors}
              label="Alerta"
              placeholder="Justifique"
              formValue="txAlerta"
              disabled={!flagAlerta}
            />
          </Grid>
          <Grid
            gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteInput
              errors={errors}
              name="matriculaContraparte"
              onChangeText={useDebounce(handleSearchMatricula, 600)}
              value={selectedMatriculaContraparte || null}
              options={
                matriculas.filter((m) =>
                  substitutoList.every(
                    (sub) => sub?.matriculaSubstituto !== m.label
                  )
                ) || []
              }
              formValue="matriculaContraparte"
              optionValue="label"
              label="Matrícula Contraparte"
              onChange={(selectedValue, value) => {
                handleSelectedContraparte(value)
              }}
              valueName="value"
              noFilter
              marginTop="0.25rem"
              required
            />
            <AutoCompleteInput
              errors={errors}
              name="nmContraparte"
              onChangeText={useDebounce(handleSearchAnalista, 600)}
              value={selectedContraparte}
              options={analistas}
              optionValue="label"
              label="Nome do Contraparte"
              formValue="nmContraparte"
              onChange={(selectedValue, value) => {
                handleSelectedContraparte(value)
              }}
              valueName="value"
              noFilter
              marginTop="0.25rem"
            />

            <Input
              disabled
              control={control}
              errors={errors}
              label="Ramal"
              formValue="ramalContraparte"
              placeholder="Nº"
              required
              min={0}
            />
            <Input
              disabled
              type="email"
              control={control}
              errors={errors}
              label="E-mail"
              formValue="emailContraparte"
              placeholder="Endereço de E-mail"
              required
            />
          </Grid>

          {substitutoList?.length === 0 && addSubstituto}
          {substitutoList?.map((substitutoItem, index) => (
            <>
              <Grid
                key={index}
                gridCols="1.1fr 2fr 1fr 2.9fr 0.5fr 0.5fr"
                gridGap={`0 ${SPACING.spacing10}`}
                margin={`0 0 ${SPACING.spacing30} 0`}
              >
                <AutoCompleteInput
                  name="matriculaSubstituto"
                  onChangeText={handleSearchMatricula}
                  value={substitutoItem?.matriculaSubstituto}
                  options={
                    matriculas.filter(
                      (m) =>
                        m.label !== matriculaContraparte &&
                        substitutoList.every(
                          (sub) => sub?.matriculaSubstituto !== m.label
                        )
                    ) || []
                  }
                  optionValue="label"
                  label="Matrícula Substituto"
                  onChange={(selectedValue, value) => {
                    handleSelectedSubstituto(value, index)
                  }}
                  valueName="value"
                  noFilter
                  marginTop="0.25rem"
                />
                <AutoCompleteInput
                  name="nmSubstituto"
                  onChangeText={handleSearchAnalista}
                  value={substitutoItem?.nmSubstituto}
                  options={analistas}
                  optionValue="label"
                  label="Nome do Substituto"
                  onChange={(selectedValue, value) => {
                    handleSelectedSubstituto(value, index)
                  }}
                  valueName="value"
                  noFilter
                  marginTop="0.25rem"
                />
                <Input
                  disabled
                  //control={control}
                  //errors={errors}
                  label="Ramal"
                  value={substitutoItem?.ramalSubstituto}
                  //formValue="ramalSubstituto"
                  placeholder="Nº"
                  min={0}
                />
                <Input
                  disabled
                  type="email"
                  // control={control}
                  // errors={errors}
                  label="E-mail"
                  value={substitutoItem?.emailSubstituto}
                  //formValue="emailSubstituto"
                  placeholder="Endereço de E-mail"
                />

                <Button
                  text="+"
                  onClick={addSubstituto}
                  marginTop={SPACING.spacing10}
                />
                {index > 0 && (
                  <Button
                    text="-"
                    onClick={() => removeSubstituto(index)}
                    marginTop={SPACING.spacing10}
                  />
                )}
              </Grid>
            </>
          ))}

          <Grid
            gridCols="1.1fr 2fr 1fr 2.9fr 1.1fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteInput
              name="matriculaComprador"
              onChangeText={useDebounce(handleSearchMatricula, 600)}
              value={selectedMatriculaComprador || null}
              options={matriculas || []}
              optionValue="label"
              label="Matrícula Comprador"
              onChange={(selectedValue, value) => {
                handleSelectedComprador(value)
              }}
              valueName="value"
              noFilter
              marginTop="0.25rem"
            />
            <AutoCompleteInput
              name="nmComprador"
              onChangeText={useDebounce(handleSearchAnalista, 600)}
              value={selectedComprador}
              options={analistas}
              optionValue="label"
              label="Nome do Comprador"
              onChange={(selectedValue, value) => {
                handleSelectedComprador(value)
              }}
              valueName="value"
              noFilter
              marginTop="0.25rem"
            />
            <Input
              control={control}
              label="Ramal"
              placeholder="Nº"
              disabled
              formValue="ramalComprador"
              min={0}
            />
            <Input
              type="email"
              control={control}
              label="E-mail"
              placeholder="Endereço de E-mail"
              formValue="emailComprador"
              disabled
            />
            <Input
              control={control}
              type="number"
              label="Unidade do Comprador"
              placeholder="Unidade do Comprador"
              formValue="unidadeComprador"
              min={0}
              disabled
            />
          </Grid>
          <UnidadeGestoraFields
            gridCols={{
              Diretoria: 6,
              DiretoriaExecutiva: 6,
              Gerencia: 6,
              GerenciaGeral: 6,
              Unidade: 12,
              spacing: 1
            }}
            renderUnidadeSelect
            defaultValue={unidadeGestoraId}
            disableFields={[
              'DiretoriaExecutiva',
              'Diretoria',
              'GerenciaGeral',
              'Gerencia',
              'Unidade'
            ]}
            control={control}
            formValue="idUnidadeGestora"
            disabled={isSub ? true : false}
          />
          <Grid
            gridCols="1fr 2fr 1fr 2fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`${SPACING.spacing30} 0 ${SPACING.spacing30} 0`}
          >
            <AutoCompleteInput
              errors={errors}
              name="cdGrupoMercadoria"
              marginTop="0.26rem"
              options={grpMercadorias}
              value={selectedGrupoMercadoria || null}
              optionValue="cdGrupoMercLegado"
              label="Cód. Grupo Mercadoria"
              formValue="cdGrupoMercLegado"
              valueName="idGrupoMercadoria"
              onChange={(selectedValue, value) => {
                handleSelectedGrpMercadoria(
                  selectedValue,
                  grpMercadorias.find(
                    (grupoMercadoria) =>
                      grupoMercadoria.idGrupoMercadoria === value
                  )?.txDescricao
                )
              }}
            />
            <Input
              control={control}
              errors={errors}
              label="Descrição do Grupo Mercadoria"
              placeholder="Descrição"
              formValue="descGrupoMercadoria"
              disabled
            />
            <AutoCompleteInput
              errors={errors}
              name="cdHierarquiaProd"
              marginTop="0.26rem"
              options={hierarquiaProdutos}
              value={selectedHierarquiaProduto?.toString() || null}
              optionValue="cdHierarquiaProduto"
              label="Cód. Hierarquia Produto"
              formValue="cdHierarquiaProduto"
              valueName="idHierarquiaProduto"
              onChange={(selectedValue: string, value: number) => {
                handleSelectedHierarquiaProduto(
                  selectedValue,
                  value,
                  hierarquiaProdutos.find(
                    (hierarquiaProduto) =>
                      hierarquiaProduto.idHierarquiaProduto === value
                  )?.txDescricao
                )
              }}
            />
            <Input
              value={descricaoHierarquiaProduto || ''}
              errors={errors}
              label="Descrição Hierarquia Produto"
              placeholder="Descrição"
              formValue="descHierarquiaProduto"
              disabled
            />
          </Grid>

          <Grid
            gridCols="8fr "
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <ChipInput
              mensagem="Pressione espaço para selecionar um E-mail"
              errors={errors}
              enableInsertOnEnter
              control={control}
              label="E-mail documentação trabalhista"
              formValue="emailsTrabalhistas"
              onKeyUp={(event) => {
                if (event?.target?.value?.trim()) {

                  const email = event?.target?.value?.trim();
                  const emailsTrabalhistas = getValues('emailsTrabalhistas');

                  if (emailsTrabalhistas.includes(email)) {
                    setError('emailsTrabalhistas', {
                      message: 'E-mail já cadastrado neste contrato, por favor, digite outro',
                      type: 'custom'
                    })
                  }
                  else {
                    setError('emailsTrabalhistas', {
                      message:
                        'E-mail não confirmado! Pressione ENTER caso queira incluí-lo.',
                      type: 'custom'
                    });
                  }
                  clearErrors('emailsTrabalhistas')
                  return;
                }
              }
              }
              onBlur={(event) => {
                if (event?.target?.value?.trim()) {
                  inputTypingValue.current = event?.target?.value?.trim()
                  return
                }
                //clearErrors('emailsTrabalhistas')
                inputTypingValue.current = event?.target?.value?.trim()
              }}
              placeholder=""
              only="email"
              flExclusao={flExclusao}
              setFlExclusao={setFlExclusao}
            />
          </Grid>
          <Grid
            gridCols="8fr"
            gridGap={`0 ${SPACING.spacing10}`}
            margin={`0 0 ${SPACING.spacing5} 0`}
          >
            <Input
              maxLength={500}
              control={control}
              label="Observação"
              formValue="txObservacao"
              multiline
            />
          </Grid>
        </SimpleCollapse>

        {isSub && (
          <SimpleCollapse title="DADOS DO CONTRATO PRINCIPAL">
            <Grid
              gridCols="1fr 3.5fr 3.5fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <Input
                label="Contrato"
                placeholder="Nº"
                value={subContract?.cdContrato || null}
                disabled
              />
              <Input
                value={subContract?.nmFornecedor || null}
                label="Fornecedor"
                placeholder="Nome do Fornecedor"
                disabled
              />

              <Input
                value={subContract?.txObservacao || null}
                disabled
                label="Observação"
                placeholder="Observação"
                multiline
              />
            </Grid>
            <Grid
              gridCols="2fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <TextArea
                value={subContract?.txObjetoContrato || null}
                disabled
                label="Objeto do contrato"
                placeholder="Objeto do contrato"
                count={subContract?.txObjetoContrato?.length}
                limitCount={150}
                maxLength={150}
              />
            </Grid>
          </SimpleCollapse>
        )}

        {loadingEvidencia ? (
          <LoadingIcon
            colorIcon={COLORS.blueFonts}
            marginTop={SPACING.spacing20}
          />
        ) : (
          <SimpleCollapse title="ANEXAR EVIDÊNCIAS">
            <Grid
              gridCols="6fr 3fr"
              gridGap={`0 ${SPACING.spacing10}`}
              margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
            >
              <InputFile
                onChange={(files) => {
                  const twoGigaBytes = 17179869184

                  if (files[0].size >= twoGigaBytes) {
                    showModal({
                      hideButtonCancel: true,
                      message:
                        'O arquivo anexado não pode ter tamanho maior que 2GB',
                      titleModal: 'Atenção',
                      txtButtonConfirm: 'OK',
                      type: 'alert'
                    })
                    return
                  }
                  handleChangeFile(files)
                }}
                renderInput={false}
                required
              />
              {arquivosSelecionados?.length > 0 && (
                <Input
                  value={searchFile}
                  label="Pesquisa Geral"
                  placeholder="Pesquisar"
                  onChange={(e) => setSearchFile(e.target.value)}
                  inputIcon={<MagnifyingGlassIcon />}
                />
              )}
            </Grid>
            {arquivosSelecionados?.length > 0 && (
              <Grid
                gridCols="12fr"
                gridGap={`0 ${SPACING.spacing10}`}
                margin={`${SPACING.spacing20} 0 ${SPACING.spacing30} 0`}
              >
                <AttachedFiles
                  tableData={handleFilterFilesTable()}
                  handleDeleteFile={handleFileToDelete}
                />
              </Grid>
            )}
          </SimpleCollapse>
        )}

        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button
            text="Salvar e Finalizar"
            type="submit"
            marginLeft={SPACING.spacing20}
            disabled={getFieldState('emailsTrabalhistas').invalid}
          />
          <Button
            text="Limpar"
            variantButton="text"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
            onClick={handleClearForm}
          />
        </Row>
      </Form>
      <SuccessModal
        message={substituteErrorMsg}
        open={isError}
        type="error"
        handleConfirm={toggleError}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
      <SuccessModal
        message={successMsg}
        open={isSuccess}
        type="sucess"
        handleConfirm={() => setSuccess(false)}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}
